module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0120.jpg?v=bb0d07fd";